import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSession, PageTitle, PseudoStates } from '@cordata/buffet';
import { groupBy } from 'lodash';
import { startOfDay, format } from 'date-fns';
import { ListGroup, ListGroupItem, ListGroupItemHeading, Badge } from 'reactstrap';

import { authorizedInstance as Rb } from '~/utils/api/instances';
import { deburrObject } from '~/utils/api/normalizers';

const PatientsAudit = () => {
  const { debugMode } = useSession();
  const { patient_id: patientId } = useParams();
  const [data, setData] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    Rb.get(`/patients/${patientId}/audit-messages`)
      .then(r => r.data.data.map(deburrObject))
      .then(r => groupBy(r, (msg => startOfDay(msg.messageDate))))
      .then(setData)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, []);

  return (
    <>
      <PageTitle>Activity Log</PageTitle>

      {status === 'success'
        ? (
          <ListGroup>
            {Object.keys(data).map(d => (
              <ListGroupItem>
                <ListGroupItemHeading>
                  {format(d, 'ddd MMM Do YYYY ')}
                  <Badge color="tertiary" pill>
                    {data[d].length}
                  </Badge>
                </ListGroupItemHeading>

                <ListGroup className="my-3">
                  {data[d].map(msg =>
                    <ListGroupItem>{format(msg.messageDate, 'h:mm A')} - {msg.formattedMessage}{debugMode && (<div className="pt-3">serviceMethod: {msg.serviceMethod}<br />target: {msg.targetType} ( {msg.targetUid} )</div>)}</ListGroupItem>)}
                </ListGroup>
              </ListGroupItem>
            ))}
          </ListGroup>
        ) : (
          <PseudoStates status={status} />
        )}
    </>
  );
};

export default PatientsAudit;
